import { render, staticRenderFns } from "./View_Badges.vue?vue&type=template&id=f88081a6&scoped=true&"
import script from "./View_Badges.vue?vue&type=script&lang=js&"
export * from "./View_Badges.vue?vue&type=script&lang=js&"
import style0 from "./View_Badges.vue?vue&type=style&index=0&id=f88081a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88081a6",
  null
  
)

export default component.exports